import { motion } from "framer-motion";
import { Shield, Clock, Banknote, Users, Award, HeartHandshake } from "lucide-react";

const FADE_IN_UP = { initial: { opacity: 0, y: 20 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true } };
const STAGGER_BASE = 0.08;

const REASONS = [
  {
    icon: Shield,
    title: "Fully Insured — Up to £50,000",
    description: "Every item is covered. We carry full goods-in-transit and public liability insurance, so you never worry about 'what ifs'.",
  },
  {
    icon: Clock,
    title: "We Show Up On Time. Always.",
    description: "We know your day revolves around us being there. Our on-time guarantee means we arrive when we say — or you get a discount.",
  },
  {
    icon: Banknote,
    title: "Transparent Pricing — No Nasty Surprises",
    description: "The price we quote is the price you pay. No hidden staircase fees, no fuel surcharges, no last-minute extras.",
  },
  {
    icon: Users,
    title: "Your Local Team, Not Agency Staff",
    description: "Our crews are full-time, trained employees who take pride in their work — not random day labourers hired the night before.",
  },
  {
    icon: Award,
    title: "500+ Five-Star Reviews",
    description: "Real reviews from real customers across Cardiff and London. We've earned our reputation one careful move at a time.",
  },
  {
    icon: HeartHandshake,
    title: "We Treat Your Home Like Ours",
    description: "Floor protectors, banister wraps, furniture blankets — all included as standard. Your property is safe with us.",
  },
];

export const WhyChooseUs = () => (
  <section className="section-padding bg-white" data-testid="why-choose-us">
    <div className="container-max">
      <div className="text-center mb-16">
        <span className="text-xs tracking-[0.2em] uppercase font-bold text-[#FF5A1F] mb-2 block">Why Hitech Transit</span>
        <h2 className="text-3xl md:text-4xl font-['Outfit'] font-bold tracking-tight text-[#0F172A] mt-2">
          Here's Why Thousands Trust Us With Their Move
        </h2>
        <p className="text-slate-600 mt-4 max-w-2xl mx-auto">
          We're not the cheapest — we're the ones you'll actually recommend to your mates.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {REASONS.map((reason, index) => (
          <motion.div
            key={reason.title}
            className="group"
            {...FADE_IN_UP}
            transition={{ delay: index * STAGGER_BASE }}
          >
            <div className="p-6 h-full border border-slate-100 hover:border-[#FF5A1F]/30 hover:shadow-lg transition-all duration-300">
              <div className="w-12 h-12 bg-[#FF5A1F]/10 flex items-center justify-center mb-5 group-hover:bg-[#FF5A1F] transition-colors">
                <reason.icon className="w-6 h-6 text-[#FF5A1F] group-hover:text-white transition-colors" />
              </div>
              <h3 className="text-lg font-['Outfit'] font-bold text-[#0F172A] mb-2 leading-tight">
                {reason.title}
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed">
                {reason.description}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
